
import Vue from "vue"

interface Paginator {
  limit: number
  page: number
  pages: number
  total: number
}

export default Vue.extend({
  props: {
    paginator: {
      type: Object as VuePropType<Nullable<Paginator>>,
      default: null,
    },
  },

  computed: {
    hasPrevious (): boolean {
      return (this.paginator?.page ?? 1) > 1
    },
    hasNext (): boolean {
      const { paginator } = this
      return (paginator?.page ?? 1) < (paginator?.pages ?? 1)
    },

    hasPagination (): boolean {
      const { paginator } = this
      return (paginator?.total ?? 0) > (paginator?.limit ?? 1)
    },
  },

  methods: {
    onPageChange (page: number) {
      if (page !== (this.paginator?.page ?? 1)) this.$emit("change", page)
    },

    onNextClick () {
      if (!this.hasNext) return
      let page = (this.paginator?.page ?? 1)
      this.$emit("change", ++page)
    },

    onPreviousClick () {
      if (!this.hasPrevious) return
      let page = (this.paginator?.page ?? 1)
      this.$emit("change", --page)
    },
  },
})
